import $ from "jquery";

import consentStorage from './consentStorage';

const CONTAINER_SELECTOR = '[data-cookie-notice]';
const DISMISSED_NOTICE_KEY_ATTR = 'data-cookie-notice-dismiss';
const DISMISS_BUTTONS_SELECTOR = '[data-cookie-notice-dismiss]';
const BUTTON_SELECTOR = '[data-cookie-notice-button]';
const CONSENT_KEYS_ATTR = 'data-cookie-notice-consent-keys';

export default class CookieNotice {
    init() {
        this.setupEvents();
    }

    setupEvents() {
        $('body').on('click', BUTTON_SELECTOR, (ev) => {
            this.onButtonClick(ev);
        });
        $('body').on('click', DISMISS_BUTTONS_SELECTOR, (ev) => {
            this.onDismissClick(ev);
        });
    }

    onDismissClick (ev) {
        const $target = $(ev.target);
        const dismissKey = ($target.attr(DISMISSED_NOTICE_KEY_ATTR) || '');

        if (dismissKey) {
            consentStorage.set(dismissKey);
        }

        $(CONTAINER_SELECTOR).remove();
    }

    onButtonClick (ev) {
        const $target = $(ev.target);
        const consentKeys = ($target.attr(CONSENT_KEYS_ATTR) || '').split(',');

        consentKeys.forEach((consentKey) => {
            if (consentKey) {
                consentStorage.set(consentKey);
            }
        });

        this.onDismissClick(ev);

        ev.preventDefault();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/CookieConsent/Components/CookieNotice.js